<template>
    <div class="switch-medium" @click="switchToggle()"  :class="[{right:switchMode==local.config.right.value,left:switchMode==local.config.left.value},propsClass]">
         <div class="switch-medium-btn backgroundOrange" ></div>
         <span class="right-option" :class="{active:switchMode==local.config.right.value}" >{{local.config.right.text}}</span>
         <span class="left-option" :class="{active:switchMode==local.config.left.value}" >{{local.config.left.text}}</span>
    </div>
</template>

<script>
export default {
    props:['default','config','propsClass'], 
    data(){
        return {
            switchMode:this.default,
            local:{config:this.config}
        }
    },
    components: {
  
    },
    watch: {
        default:function(val){
            this.switchMode=val
        },
        config:function(val){
            this.local.config=val
        },
        switchMode:function(val){
            if(val==this.local.config.right.value){
                this.$emit('switch',this.local.config.right.value)
            }else{
                this.$emit('switch',this.local.config.left.value)
            }
        }
    },
    methods:{
        switchToggle(){
            if(this.switchMode==this.local.config.right.value){
                this.switchMode=this.local.config.left.value
            }else{
                this.switchMode=this.local.config.right.value
            }
        }
    }
}
</script>

<style>
</style>
